import React from "react";
import { useFormContext, useController } from "react-hook-form";
import { InputLabel } from "../InputLabel/InputLabel";
import { InputErrorMessage } from "../InputErrorMessage/InputErrorMessage";

export interface PaziaColorPickerProps {
  name: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  hideErrors?: boolean;
  onChange?: (color: string) => void;
}

export const PaziaColorPicker = ({
  name,
  label,
  required,
  disabled,
  className = "",
  hideErrors,
  onChange,
}: PaziaColorPickerProps): JSX.Element => {
  const { control } = useFormContext();
  const { field } = useController({ name, control });

  const onChangeHandler = (color: string) => {
    field.onChange(color);
    if (onChange) onChange(color);
  };

  const disabledClass = disabled
    ? "disabled:border-slate-200 dark:disabled:border-slate-700 disabled:bg-slate-100 dark:disabled:bg-slate-700 disabled:cursor-not-allowed opacity-50"
    : "";

  return (
    <div className={`flex flex-col ${className}`}>
      <InputLabel label={label} required={required} name={name} />
      <div className="flex gap-2">
        <input
          type="color"
          value={field.value || "#000000"}
          onChange={(e) => onChangeHandler(e.target.value)}
          disabled={disabled}
          className={`h-[2.375rem] w-12 cursor-pointer rounded border border-slate-200 p-1 dark:border-slate-700 ${disabledClass}`}
        />
        <input
          type="text"
          value={field.value || ""}
          onChange={(e) => onChangeHandler(e.target.value)}
          disabled={disabled}
          placeholder="#000000"
          className={`form-input h-[2.375rem] flex-1 dark:bg-slate-800 ${disabledClass}`}
        />
      </div>
      {!hideErrors && <InputErrorMessage name={name} />}
    </div>
  );
};
